export default "__VITE_ASSET__Be9DmvYG__"